import { EMPTY_STRING } from '../../../../constants/common'

export function toUpperCaseAndSpacelessValue(value) {
  return value.toUpperCase().replace(/\s/g, EMPTY_STRING)
}
